import React, { FC, memo, useEffect, useState } from "react";

import MaterialTable, { Column } from "material-table";
import { Box, CircularProgress } from "@material-ui/core";
import { useSnackbar } from "notistack";

import { updatePastaPrice } from "../api/updatePastaPrice";
import { getPastasList } from "../api/getPastasList";
import { GetPastasResponse } from "../api/getPastasList/getPastasList.typed";

const localization = {
  header: { actions: "" },
  pagination: {
    labelDisplayedRows: "{from}-{to} из {count}",
  },
  toolbar: {
    searchPlaceholder: "Поиск",
    searchTooltip: "Поиск",
  },
  body: {
    emptyDataSourceMessage: "Нет данных",
    filterRow: {
      filterTooltip: "Фильтр",
    },
  },
  grouping: {
    placeholder: "Для группировки перетащите заголовок в эту область",
    groupedBy: "Сгрупировано по",
  },
};

const columns: Column<GetPastasResponse>[] = [
  { title: "Код", field: "base", editable: "never" },
  { title: "Цена", field: "price", render: (rowData) => rowData.price + " ₽" },
];

const PriceChanger: FC = memo(() => {
  const { enqueueSnackbar } = useSnackbar();

  const [data, setData] = useState<GetPastasResponse[] | null>(null);

  useEffect(() => {
    const fetchDataAsync = async () => {
      const pastas = await getPastasList();
      setData(pastas);
    };
    fetchDataAsync();
  }, []);

  if (data === null) {
    return (
      <Box justifyContent="center" alignItems="center" display="flex">
        <CircularProgress color="primary" />
      </Box>
    );
  }
  return (
    <MaterialTable
      columns={columns}
      data={data}
      localization={localization}
      components={{
        Container: (props) => <div>{props.children}</div>,
      }}
      editable={{
        onRowUpdate: async (newData, oldData) => {
          if (oldData) {
            try {
              await updatePastaPrice(newData.id, newData.price);

              enqueueSnackbar("Изменение цены проищошло успешно.", {
                variant: "success",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
                autoHideDuration: 3000,
              });
            } catch (error) {
              enqueueSnackbar("Произошла ошибка при изменении цены.", {
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
                autoHideDuration: 3000,
              });
            }
            const dataUpdate = [...data];
            // @ts-ignore
            const index = oldData.tableData.id;
            dataUpdate[index] = newData;
            setData([...dataUpdate]);
          }
        },
      }}
      options={{
        grouping: false,
        search: true,
        minBodyHeight: "calc(100vh - 200px)",
        paging: false,
      }}
      title="Изменение цены пасты"
    />
  );
});

export { PriceChanger };
